export var formAddBusiness = {
    ownerName: "",
    ownerIdNumber: "",
    propertyTypeId: "",
    businessShift: "",
    sameAddress: false,
    Province: "",
    Town: "",
    Sector: "",
    typeConstruction: "",
    propertyAddress: "",
    coverageNotes: "",
    // typeProperty: "",
    buildingValue: "",
    merchandiseValue: "",
    furnitureValue: "",
    totalInsuredValue: "",
    insuredProperty: "",
    damageBackup: "",
};
export var propertyStatusList = [
    {
        id: "1",
        name: "Propio",
        value: "ownedProperty",
    },
    {
        id: "2",
        name: "Alquilado",
        value: "rentProperty",
    },
];
export var FormsBusinessDTO = {
    section1Title: "Datos del negocio",
    section2Title: "Ubicación de la propiedad",
    section3Title: "Valores asegurados",
    labelButtonBack: "Anterior",
    disablePropertyType: true,
    isEditMode: true,
    showBtnCalcRate: true,
    showBtnNext: true,
    showResumen: true,
    ProvinceList: [],
    TownList: [],
    SectorList: [],
    propertyTypeList: [],
    propertyStatusList: propertyStatusList,
    businessShiftList: [],
    typeConstructionList: [],
    onNext: function () { },
};
